export function getdata() {
	var obj = {
		headData: [{
				title: "项目",
				prop: "zclxmc",
				width: "200"
			},
			{
				title: "档次",
				prop: "lanci",
				width: "200"
			},
			{
				title: "税额",
				prop: "zhuancse",
				width: "200"
			}
		],
		tableData: [{
				zclxmc: '本期进项税额转出额',
				lanci: '13=14至23之和',
				zhuancse: ''
			},
			{
				zclxmc: '其中:免税项目用',
				lanci: '14',
				zhuancse: ''
			},
			{
				zclxmc: '集体福利、个人消费',
				lanci: '15',
				zhuancse: ''
			},
			{
				zclxmc: '非正常损失',
				lanci: '16',
				zhuancse: ''
			},
			{
				zclxmc: '简易计税方法征税项目用',
				lanci: '17',
				zhuancse: ''
			},
			{
				zclxmc: '免抵退稅办法不得抵扣的进项税额',
				lanci: '18',
				zhuancse: ''
			},
			{
				zclxmc: '纳税检查调减进项税额',
				lanci: '19',
				zhuancse: ''
			},
			{
				zclxmc: '红字专用发票信息表注明的进项税额',
				lanci: '20',
				zhuancse: ''
			},
			{
				zclxmc: '上期留抵税额抵减欠税',
				lanci: '21',
				zhuancse: ''
			},
			{
				zclxmc: '上期留底税额退税',
				lanci: '22',
				zhuancse: ''
			},
			{
				zclxmc: '异常凭证转出进项税额',
				lanci: '23a',
				zhuancse: ''
			},
			{
				zclxmc: '其他应作进项税额转出的情形',
				lanci: '23b',
				zhuancse: ''
			}
		],
		nsrsbhData: [{
			nsrsbh: "",
			nsrmc: ""
		}]
	}
	return obj
}
